import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";

const disciplines = [
  { name: "Electrical Engineering", count: "15+ Calculations" },
  { name: "Mechanical Engineering", count: "12+ Calculations" },
  { name: "HVAC Systems", count: "18+ Calculations" },
  { name: "Firefighting Systems", count: "10+ Calculations" },
  { name: "Plumbing Systems", count: "14+ Calculations" },
  { name: "Light Current Systems", count: "8+ Calculations" },
  { name: "Automation & BMS", count: "6+ Calculations" },
  { name: "Power Systems", count: "10+ Calculations" },
  { name: "Low Voltage Systems", count: "9+ Calculations" },
  { name: "ELV Systems", count: "7+ Calculations" },
  { name: "Renewable Energy", count: "5+ Calculations" },
  { name: "Smart Building Systems", count: "4+ Calculations" },
  { name: "Industrial MEP", count: "8+ Calculations" },
  { name: "Data Centers MEP", count: "6+ Calculations" },
  { name: "Infrastructure MEP", count: "7+ Calculations" },
];

export function DisciplinesSection() {
  return (
    <section id="disciplines" className="border-b border-border/40 bg-muted/30 py-24">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <motion.h2 
            className="mb-4 text-3xl font-bold md:text-4xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            All MEP Disciplines Covered
          </motion.h2>
          <motion.p 
            className="text-lg text-muted-foreground"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            From traditional MEP to smart buildings and data centers
          </motion.p>
        </div>

        <motion.div 
          className="flex flex-wrap justify-center gap-3"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {disciplines.map((discipline, index) => (
            <motion.div
              key={discipline.name}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
            >
              <Badge 
                variant="outline" 
                className="cursor-pointer px-4 py-2 text-sm transition-all hover:border-primary hover:bg-primary/10"
              >
                <span className="font-semibold">{discipline.name}</span>
                <span className="mx-2 text-muted-foreground">•</span>
                <span className="text-muted-foreground">{discipline.count}</span>
              </Badge>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
